export default "__VITE_PUBLIC_ASSET__aa4d273e__"